import React, { useEffect, useState } from "react";
import "./styles.css";

const Switch = ({ checked, onCheckedChange }) => {
  const [isOn, setIsOn] = useState(false);

  const toggleSwitch = () => {
    if (onCheckedChange) onCheckedChange(!isOn);
    else setIsOn(!isOn);
  }

  useEffect(() => {
    setIsOn(!!checked);
  }, [ checked ]);

  return (
    <div
      className={`switch-container ${isOn ? "on" : "off"}`}
      onClick={toggleSwitch}
    >
      <div className="switch-thumb"></div>
    </div>
  );
};

export default Switch;
